import { Image, Tab, Tabs } from '@heroui/react';
import _ from 'lodash';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Done from '@/assets/images/done.png';
import { AppEvent } from '@/patient-app-common/types/ApplicationEvent';
import useAppEvents from '@/patient-app-common/hooks/useAppEvents';

import { EduEvent } from './EduEvent';
import { SurveyEvent } from './SurveyEvent';

export function MessageList() {
  const { t } = useTranslation('home');
  const { clinicalContact, isLoading, unread } = useAppEvents();
  const [tab, setTab] = useState('all');

  const surveys = useMemo(() => {
    return _.filter(unread, ['eventType', 'survey']);
  }, [unread]);

  const getEventCard = (appEvent: AppEvent) => {
    switch (appEvent.eventType) {
      case 'education':
        return (
          <EduEvent
            avatar={
              clinicalContact?.profilePicture || '/icons/doctor_avatar.png'
            }
            event={appEvent}
          />
        );

      case 'survey':
        return (
          <SurveyEvent
            avatar={
              clinicalContact?.profilePicture || '/icons/doctor_avatar.png'
            }
            event={appEvent}
          />
        );

      default:
        return <div />;
    }
  };

  if (isLoading) return null;

  return (
    <>
      <h2 className="text-2xl pt-8 space-y-4">{t('messagelist.title')}</h2>
      <Tabs
        color="primary"
        fullWidth
        size="md"
        selectedKey={tab}
        onSelectionChange={(key) => {
          setTab(key.toString());
        }}
        className={_.isEmpty(surveys) ? 'hidden' : ''}
        variant="bordered"
      >
        <Tab key="all" title={t('messagelist.button.all')}>
          {unread.map((appEvent) => (
            <div key={appEvent.id} className="mb-4">
              {getEventCard(appEvent)}
            </div>
          ))}
          {_.isEmpty(unread) && (
            <div className="flex flex-col justify-center items-center">
              <Image src={Done} width={400} disableSkeleton />
              <p className="py-4 text-center">
                {t('messagelist.empty', { context: tab })}
              </p>
            </div>
          )}
        </Tab>
        <Tab
          key="survey"
          title={`${t('messagelist.button.survey')} (${surveys.length})`}
        >
          {surveys.map((appEvent) => (
            <div key={appEvent.id} className="mb-4">
              {getEventCard(appEvent)}
            </div>
          ))}
        </Tab>
      </Tabs>
    </>
  );
}
